import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material";
import { useState } from "react";
import { styled } from "styled-components";
import { mainServices } from "../data";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

const VideoSlider = () => {
  const navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);

  const handleClick = (direction) => {
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : mainServices.length - 1);
    } else {
      setSlideIndex(slideIndex < mainServices.length - 1 ? slideIndex + 1 : 0);
    }
  };

  const handleButtonClick = (id) => {
    if (id === 1) {
      return navigate(`/mainContractorService/`);
    }
    return navigate(`/service/${id}`);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClick("right"),
    onSwipedRight: () => handleClick("left"),
    preventDefaultTouchmoveEvent: true,
    swipeDuration: Infinity,
  });

  return (
    <Container id="videoSlider" {...handlers}>
      <ArrowLeft onClick={() => handleClick("left")}>
        <ArrowLeftOutlined />
      </ArrowLeft>
      <Wrapper slideIndex={slideIndex}>
        {mainServices.map((item) => (
          <Slide key={item.id}>
            <VideoContainer>
              {item.mediaType === "video" ? (
                <Video src={`/vid/${item.mediaUrl}`} autoPlay muted loop playsInline/>
              ) : (
                <Image src={`/img/services/${item.mediaUrl}`} />
              )}
            </VideoContainer>
            <InfoContainer>
              {/* To allow InfoView items to justify as center */}
              <InfoView>
                <Title>{item.title}</Title>
                <Description>{item.desc}</Description>
                <Button onClick={() => handleButtonClick(item.id)}>
                  EXPLORE NOW
                </Button>
              </InfoView>
            </InfoContainer>
          </Slide>
        ))}
      </Wrapper>
      <ArrowRight onClick={() => handleClick("right")}>
        <ArrowRightOutlined />
      </ArrowRight>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  scroll-snap-align: center;
`;

const ArrowLeft = styled.div`
  width: 50px;
  height: 50px;
  background-color: #a9a9a9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: white;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const ArrowRight = styled.div`
  width: 50px;
  height: 50px;
  background-color: #a9a9a9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: white;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  transition: all 1.5s ease;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
`;

const Slide = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
`;

const VideoContainer = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 1);
`;

const Video = styled.video`
  object-fit: cover;
  opacity: 0.3;
  height: 100vh;
  width: 100vw;
`;

const Image = styled.img`
  height: 100vh;
  width: 100vw;
  object-fit: cover;
  opacity: 0.5;
`;

const InfoContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 7%;
`;

const InfoView = styled.div`
  color: white;
  width: 75%;
  /* background-color: RED; */
  @media (max-width: 768px) {
    width: 77%;
    margin-bottom: 40px;
  }
`;

const Title = styled.h1`
  font-size: 65px;
  letter-spacing: 5px;
  width: 95%;
  font-family: "Kestrel";
  /* background-color: blue; */
  @media (max-width: 768px) {
    font-size: 75px;
    font-size: 30px;
    letter-spacing: 2px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  font-weight: 500;
  width: 80%;
  padding: 10px 0px 50px 120px;
  @media (max-width: 768px) {
    font-size: 15px;
    text-align: auto;
    align-self: flex-end;
    width: 80%;
    padding: 10px 0px 30px 40px;
  }
`;

const Button = styled.button`
  padding: 10px 50px;
  font-size: 20px;
  border-radius: 10px;
  background-color: white;
  border-width: 0px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
  @media (max-width: 768px) {
    padding: 10px 10px;
    font-size: 14px;
    font-weight: bold;
  }
`;

export default VideoSlider;
